import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PublishTargetSummariesComponent } from './publish-target-summaries.component';
import { EditSocialCardComponent } from '../../components/edit-social-card/edit-social-card.component';

@NgModule({
  declarations: [
    PublishTargetSummariesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EditSocialCardComponent,
  ],
  exports: [PublishTargetSummariesComponent],
})
export class PublishTargetSummariesModule {

}
